<mat-expansion-panel (opened)="panelOpen = true; panelOpenedOnce = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="propertyFormService.isPhotosStepValid()">{{ "Photos" }}</h2>
            </div>
            <div>
                <mat-icon *ngIf="propertyFormService.isPhotosStepValid(); else notValid" class="header-toggle complete">
                    checked
                </mat-icon>
                <ng-template #notValid>
                    <mat-icon *ngIf="!panelOpenedOnce || !panelOpen; else panelOpened" class="header-toggle">
                        expand_more
                    </mat-icon>
                    <ng-template #panelOpened>
                        <mat-icon *ngIf="propertyFormService.getPhotos(); else panelOpenedOnceAndNotValid" class="header-toggle">
                            expand_less
                        </mat-icon>
                        <ng-template #panelOpenedOnceAndNotValid>
                            <mat-icon class="header-toggle error">
                                close
                            </mat-icon>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-body-container mx-2">
        <div class="d-flex flex-column full-width">
            <div *ngFor="let photo of propertyFormService.getPhotos(); index as i; trackBy: trackByFn" class="d-flex flex-row full-width align-items-center">
                <mat-form-field appearance="outline" class="w-100">
                    <input type="text" matInput placeholder="Photo URL" (input)="handleUpdatePropertyPhoto(photo.id, $event)" [value]="photo.url">
                </mat-form-field>
                <mat-icon class="delete-icon mx-2" (click)="handleDeletePropertyPhoto(photo.id)">delete</mat-icon>
            </div>
            <div class="my-2">
                <button mat-raised-button class="action-button" (click)="handleAddPropertyPhoto()">
                    Add Another URL
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</mat-expansion-panel>